import { ILink, NavId, NavLabelsMap } from "types/navigation";

const filterValidLinks = (ids: NavId[]): ILink[] =>
  ids
    .filter((id) => NavLabelsMap[id] !== "Null")
    .map((id) => ({
      id,
      value: NavLabelsMap[id],
    }));

export const LINKS: ILink[] = filterValidLinks([
  NavId.Section1,
  NavId.Section2,
  NavId.Section3,
  NavId.Section4,
  NavId.Section5,
  NavId.Section6,
  NavId.Section7,
  NavId.Section9,
  NavId.Section10,
  NavId.Section11,
]);

export const LINKS_DESKTOP: ILink[] = filterValidLinks([
  NavId.Section1,
  NavId.Section2,
  NavId.Section3,
  NavId.Section4,
  NavId.Section5,
  NavId.Section6,
  NavId.Section7,
  NavId.Section8,
  NavId.Section11,
]);
